export function isTruthy(data) {
    return !!data;
}
